<template>
    <OutlineTooltip :position="position" :anchor="anchor" max-width="480px">
        <section>
            <p class="text-sm font-bold mb-2">State Bindings</p>
            <table v-if="summary.stateBindings.length" class="table-auto w-full text-left text-xs">
                <thead>
                    <tr>
                        <th class="border-b border-gray-600 px-1">entity</th>
                        <th class="border-b border-gray-600 px-1">property</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="binding in summary.stateBindings" :key="binding.id">
                        <td class="px-2 py-1 font-mono">{{ binding.entity || '—' }}</td>
                        <td class="px-2 py-1">{{ binding.property }}</td>
                    </tr>
                </tbody>
            </table>
            <p v-else class="text-xs text-gray-400">No State Bindings configured.</p>
        </section>

        <section class="mt-4">
            <p class="text-sm font-bold mb-2">Event Actions</p>
            <table v-if="summary.eventActions.length" class="table-auto w-full text-left text-xs">
                <thead>
                    <tr>
                        <th class="border-b border-gray-600 px-1">event</th>
                        <th class="border-b border-gray-600 px-1">service / action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="event in summary.eventActions" :key="event.event">
                        <td class="px-2 py-1 align-top">{{ event.event }}</td>
                        <td class="px-2 py-1">
                            <div v-for="action in event.actions" :key="action.id"
                                :class="action.isChoose ? 'text-cyan-300' : ''">
                                {{ action.label }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p v-else class="text-xs text-gray-400">No Event Actions configured.</p>
        </section>
    </OutlineTooltip>
</template>

<script setup>
import { computed } from 'vue';
import OutlineTooltip from '../../OutlineTooltip.vue';
import { buildOutlineHassSummary } from './outlineHassSummary.js';
import { getEffectiveHassConfig } from '../../../hass/hassEffective.js';

const props = defineProps({
    node: { type: Object, required: true },
    position: { type: Object, required: true },
    anchor: { type: Object, default: null },
});

const summary = computed(() => buildOutlineHassSummary(props.node, { configOf: getEffectiveHassConfig }));
</script>

